import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * LanguageSwitcher — compact TR/EN toggle button
 * variant: 'light' (white text, for dark backgrounds)
 *          'dark'  (gray text, for light backgrounds)
 */
const LanguageSwitcher = ({ variant = 'light' }) => {
  const { i18n } = useTranslation();
  const isEn = i18n.language === 'en' || i18n.language?.startsWith('en');

  const toggle = () => {
    const next = isEn ? 'tr' : 'en';
    i18n.changeLanguage(next);
    localStorage.setItem('expostand_lang', next);
  };

  const baseStyle = variant === 'light'
    ? 'border-white/30 text-white hover:bg-white/20'
    : 'border-gray-200 text-gray-700 hover:bg-gray-100';

  return (
    <button
      onClick={toggle}
      data-testid="language-switcher"
      title={isEn ? 'Türkçeye geç' : 'Switch to English'}
      className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border text-xs font-semibold transition-all ${baseStyle}`}
    >
      <span className="text-base leading-none">{isEn ? '🇹🇷' : '🇬🇧'}</span>
      <span>{isEn ? 'TR' : 'EN'}</span>
    </button>
  );
};

export default LanguageSwitcher;
